export const BASE_API = process.env.VUE_APP_BASE_API || 'https://api.joensave.com'
export const WEBSOCKETS_BASE_API = process.env.VUE_APP_WEBSOCKETS_BASE_API || 'wss://ws.joensave.com'
export const API_TOKEN_NAME = 'API-key'
export const STORAGE_TOKEN_NAME = 'auth_token'
